import React from 'react';
import PropTypes from 'prop-types';

import { EXCLUDED_OPTION_SCREEN_NAMES } from '../utils';

const ProductOption = ({ product, removeExtraCushion, ...option }) => {
  // https://stitchindustries.atlassian.net/browse/CON-3086
  if (option.optionTypeId === 135) {
    return null;
  }

  if (option.optionTypeId === 133) {
    if (option.name === 'Not included') return null;

    return (
      <>
        Extra Cushion (+${option.additional_cost})
        <span
          role="button"
          tabIndex={0}
          className="cursor-pointer absolute font-bold -right-5 text-brand"
          onClick={() => removeExtraCushion(product)}
        >
          Remove
        </span>
      </>
    );
  }

  if (EXCLUDED_OPTION_SCREEN_NAMES.includes(option.optionTypeId)) {
    return option.name;
  }

  return `${option.name} ${option.optionTypeName} ${
    option.exclude_from_sale ? ' - Limited Edition' : ''
  }`;
};

ProductOption.propTypes = {
  option: PropTypes.shape({
    exclude_from_sale: PropTypes.number,
    additional_cost: PropTypes.number,
    name: PropTypes.string,
    optionTypeId: PropTypes.number,
    optionTypeName: PropTypes.string,
  }),
  product: PropTypes.object,
  removeExtraCushion: PropTypes.func,
};

export default ProductOption;
